// utils/auth.js - Frontend helper functions

// Store authentication data
export const setAuthData = (token, user) => {
  localStorage.setItem('token', token);
  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('isAuthenticated', 'true');
};

// Get authentication data
export const getAuthData = () => {
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  
  return {
    token,
    user: user ? JSON.parse(user) : null,
    isAuthenticated: isAuthenticated === 'true'
  };
};

// Clear authentication data
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('isAuthenticated');
};

// Check if token is expired (client-side rough check)
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (error) {
    return true;
  }
};

// Get authorization header for API calls
export const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { 'Authorization': `Bearer ${token}` } : {};
};

// Check for token in URL fragment (for OAuth callback)
export const checkOAuthCallback = () => {
  const fragment = window.location.hash.substring(1); // Get fragment without #
  if (!fragment) return null;

  // Parse the fragment as query parameters
  const params = new URLSearchParams(fragment);
  const token = params.get('token');
  const userStr = params.get('user');

  if (token && userStr) {
    try {
      const user = JSON.parse(decodeURIComponent(userStr));
      // Clear the fragment from the URL to prevent reuse
      window.history.replaceState({}, document.title, window.location.pathname);
      return { token, user };
    } catch (error) {
      console.error('Error parsing OAuth callback:', error);
      return null;
    }
  }

  return null;
};
